var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGovernanceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3223 24.89L15.0319 22.2417L20.3285 23.6609L19.6189 26.3092",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6931 22.4191L16.4027 19.7708C16.4968 19.4196 16.7266 19.1202 17.0415 18.9384C17.3563 18.7566 17.7305 18.7073 18.0817 18.8014L18.88 15.822C18.9506 15.5587 19.1229 15.3341 19.3591 15.1977C19.5952 15.0614 19.8759 15.0245 20.1393 15.095C20.4026 15.1656 20.6272 15.3379 20.7636 15.5741C20.8999 15.8102 20.9368 16.0909 20.8663 16.3543L19.8905 19.9957",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0745 15.0772L19.3384 12.5276C19.24 12.1793 19.2381 11.8109 19.333 11.4617C19.4001 11.2103 19.5161 10.9745 19.6744 10.7679C19.8326 10.5613 20.03 10.3879 20.2553 10.2576L21.2289 9.70955L23.2004 16.5996C23.3487 17.1208 23.3529 17.6725 23.2126 18.1959C23.1196 18.5419 22.9649 18.8683 22.7558 19.1592L19.667 23.4834",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87891 24.89L9.16929 22.2417L3.87263 23.6609L4.58225 26.3092",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50806 22.4191L7.79844 19.7708C7.70434 19.4196 7.47458 19.1202 7.15971 18.9384C6.84484 18.7566 6.47066 18.7073 6.11947 18.8014L5.32115 15.822C5.25057 15.5587 5.07825 15.3341 4.8421 15.1977C4.60595 15.0614 4.32531 15.0245 4.06192 15.095C3.79852 15.1656 3.57396 15.3379 3.43761 15.5741C3.30127 15.8102 3.26433 16.0909 3.3349 16.3543L4.31062 19.9957",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12671 15.0772L4.86278 12.5276C4.96122 12.1793 4.96306 11.8109 4.86813 11.4617C4.80103 11.2103 4.68504 10.9745 4.5268 10.7679C4.36856 10.5613 4.17116 10.3879 3.94588 10.2576L2.97231 9.70955L1.00074 16.5996C0.852503 17.1208 0.84828 17.6725 0.988522 18.1959C1.08154 18.5419 1.2363 18.8683 1.44533 19.1592L4.53415 23.4834",
    stroke: "#C0C9FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50256 13.0001C9.88328 13.0001 11.0026 11.8808 11.0026 10.5001C11.0026 9.11941 9.88328 8.00012 8.50256 8.00012C7.12185 8.00012 6.00256 9.11941 6.00256 10.5001C6.00256 11.8808 7.12185 13.0001 8.50256 13.0001Z",
    stroke: "#C0C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5006 13.0001C16.8813 13.0001 18.0006 11.8808 18.0006 10.5001C18.0006 9.11941 16.8813 8.00012 15.5006 8.00012C14.1199 8.00012 13.0006 9.11941 13.0006 10.5001C13.0006 11.8808 14.1199 13.0001 15.5006 13.0001Z",
    stroke: "#C0C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 7C13.3813 7 14.5006 5.88071 14.5006 4.5C14.5006 3.11929 13.3813 2 12.0006 2C10.6199 2 9.50061 3.11929 9.50061 4.5C9.50061 5.88071 10.6199 7 12.0006 7Z",
    stroke: "#C0C9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceIcon);
export default __webpack_public_path__ + "static/media/governanceIcon.ccda3f81f606d2e6d099b957cbf3e2a5.svg";
export { ForwardRef as ReactComponent };